// Deterministic A/B bucket from pblk_sid, cached for the session lifetime.
// Same sid → same bucket on every call, so quiz_start and downstream events
// land in the same variant cohort in GA4 / ClickHouse.
//
// Minimal-by-design: no per-quiz config, no sticky returning-user variants,
// no API-driven selection. Issue #35 unblocks measurement with a simple hash;
// publinker#628 will later override this with a variant editor.

export type VariantId = 'A' | 'B' | 'control';

let cachedVariantId: VariantId | null = null;

export function getVariantIdForSession(pblkSid: string | undefined): VariantId {
  if (cachedVariantId) return cachedVariantId;
  if (!pblkSid) {
    cachedVariantId = 'control';
    return cachedVariantId;
  }
  let sum = 0;
  for (let i = 0; i < pblkSid.length; i++) sum += pblkSid.charCodeAt(i);
  cachedVariantId = sum % 2 === 0 ? 'A' : 'B';
  return cachedVariantId;
}

export function __resetVariantCacheForTests(): void {
  cachedVariantId = null;
}
